import { createContext, useState, useContext } from "react";
import { useAuth } from "./AuthContext";

const AppointmentsContext = createContext({
  appointments: [],
  fetchAppointments: () => {}
});
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const UserAppointments = () => useContext(AppointmentsContext);

export const AppointmentsProvider = ({ children }) => {
    const [appointments, setAppointments] = useState([]);
    const [userDoctor, setUserDoctor] = useState(null);
    const { token } = useAuth();

    const fetchDoctor = async (doctorFirstName, doctorLastName) => {
        const encodedFirstName = encodeURIComponent(doctorFirstName);
        const encodedLastName = encodeURIComponent(doctorLastName);
    
        try {
            const responseDoct = await fetch(`${API_BASE_URL}/api/doctor/getDoctorByName?firstName=${encodedFirstName}&lastName=${encodedLastName}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            });
        
            if (responseDoct.ok) {
                const responseDoctor = await responseDoct.json();
                const doctorData = {
                    value: responseDoctor.id,
                    label: `${responseDoctor.firstName} ${responseDoctor.lastName}`
                }
                setUserDoctor(doctorData);
                return doctorData;
            } else {
                console.error("Failed to get the doctor record!");
                return null;
            }
    
        } catch (error) {
            console.error("Network or server error:", error);
            return null;
        }
        };


    const fetchAppointments = async (user) => {
        try {
            let response;

            const headers = {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            };
    
            if (user.userRole === 'DOCTOR') {
                const doctorData = await fetchDoctor(user.firstName, user.lastName);
                if (!doctorData) return; // Stop if fetching doctor failed
                response = await fetch(`${API_BASE_URL}/api/appointment/doctor/${doctorData.value}`, { headers });
            } else if (user.userRole === 'ADMIN') {
                response = await fetch(`${API_BASE_URL}/api/appointment/admin/appointments/all`, { headers });
            } else {
                response = await fetch(`${API_BASE_URL}/api/appointment/user/${user.id}`, { headers });
            }
    
            if (response && response.ok) {
                const avail_records = await response.json();
                setAppointments(avail_records);
            } else {
                console.error("Error fetching availavle appointments.");
            }
    
        } catch (error) {
            console.error("Network or server error:", error);
        }
    }

    
    return (
        <AppointmentsContext.Provider value={{ appointments, fetchAppointments }}>
            {children}
        </AppointmentsContext.Provider>
    );
};